import {
  Directive,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

import { ApplicationModeEnum } from '~/core/enums/application-mode.enum';
import { IncomingRequestService } from '~/core/services/incoming-request/incoming-request.service';

import { AppModeDirective } from './app-mode.directive';

@Directive({
  selector: '[appModeFull]',
})
export class AppModeFullDirective extends AppModeDirective implements OnInit {
  constructor(
    protected readonly templateRef: TemplateRef<Element>,
    protected readonly viewContainer: ViewContainerRef,
    protected readonly incomingRequestService: IncomingRequestService
  ) {
    super(templateRef, viewContainer, incomingRequestService);
  }

  public ngOnInit(): void {
    this.appMode === ApplicationModeEnum.Full ? this.render() : this.clear();
  }
}
